import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../../base';
import { dataFieldNamingHandler, exceptionHandler } from '../../../base/decorators';
import { getFormDataWithParams } from '../../../base/utils';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { TIPS_SHOW_CGI, VIP_INFO_CGI } from './cgi-path';
var VipInfoRepository = /** @class */ (function () {
    function VipInfoRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    VipInfoRepository.prototype.getPersonalVipInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams({
                    xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf),
                });
                return [2 /*return*/, this.networkRequestService.instance.post(VIP_INFO_CGI, formData)];
            });
        });
    };
    VipInfoRepository.prototype.getPersonalTipsShow = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(TIPS_SHOW_CGI, formData)];
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], VipInfoRepository.prototype, "getPersonalVipInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], VipInfoRepository.prototype, "getPersonalTipsShow", null);
    VipInfoRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], VipInfoRepository);
    return VipInfoRepository;
}());
export default VipInfoRepository;
